// messages/t2pay/t2pay-home.messages.ts

import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "@/messages/action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "@/messages/layout/sidebar";

import { ACCOUNT_INFO_MESSAGES, AccountInfoMessages } from "./account-Info.messages";
import { DOCUMENTS_TAB_MESSAGES, DocumentsTabMessages } from "./documents-tab.messages";
import { ERROR_MESSAGES, ErrorMessages } from "./error.messages";
import { RatesTabMessages, ratesTabMessages } from "./rates-tab.messages";
import { STATEMENT_TAB_MESSAGES, StatementTabMessages } from "./statement-tab.messages";
import { TAB_LABELS_MESSAGES, TabLabelsMessages } from "./tab-labels.messages";

export type T2PayHomeMessages = SidebarMessages &
  ActionButtonMessages &
  AccountInfoMessages &
  DocumentsTabMessages &
  ErrorMessages &
  RatesTabMessages &
  TabLabelsMessages &
  StatementTabMessages & {
    pageTitle: string;
    breadCrumbTitle: string;
    accountBalanceLabel: string;
  };

export const T2PAY_HOME_MESSAGES: T2PayHomeMessages = {
  ...ratesTabMessages,
  ...SIDEBAR_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...ACCOUNT_INFO_MESSAGES,
  ...DOCUMENTS_TAB_MESSAGES,
  ...ERROR_MESSAGES,
  ...TAB_LABELS_MESSAGES,
  ...STATEMENT_TAB_MESSAGES,

  pageTitle: "Detalhes da Conta",
  breadCrumbTitle: "Plataformas",
  accountBalanceLabel: "Saldo em conta",
};
